import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase, faUser } from '@fortawesome/pro-solid-svg-icons';
import { faUserAlien } from '@fortawesome/pro-solid-svg-icons';
import React from 'react';
import { InternalApiTransactionRelatedPerson } from '../api-internal';
import { isBusinessPerson, isCounterpartyPerson, isIndividualPerson } from './helpers';

export const RelatedPersonLink = (relatedPerson: InternalApiTransactionRelatedPerson) => {
  const { personId, displayName, type } = relatedPerson;
  return (
    <Link to={`/customer/${personId}`}>
      {displayName}
      {isBusinessPerson(relatedPerson) && (
        <span>
          {' '}
          <FontAwesomeIcon icon={faBriefcase} aria-label={type} />
        </span>
      )}
      {isIndividualPerson(relatedPerson) && (
        <span>
          {' '}
          <FontAwesomeIcon icon={faUser} aria-label={type} />
        </span>
      )}
      {isCounterpartyPerson(relatedPerson) && (
        <span>
          {' '}
          <FontAwesomeIcon icon={faUserAlien} aria-label={type} />
        </span>
      )}
    </Link>
  );
};

export default RelatedPersonLink;
